(function () {
  angular.module("akitabox.ui.dialogs.floor", [
    "akitabox.ui.components.input",
    "akitabox.ui.dialogs.floor.create",
    "akitabox.ui.dialogs.floor.delete",
  ]);
})();
